import React, { useRef, useState } from "react";
import api, { API } from "@/lib/api";
import { initials } from "@/lib/utils-app";
import { Camera } from "lucide-react";
import { toast } from "sonner";

export default function EmployeeAvatar({ employee, size = 40, editable = false, onChange }) {
  const [version, setVersion] = useState(employee?.photo_updated_at || 0);
  const [failed, setFailed] = useState(false);
  const fileRef = useRef();

  // re-set when employee record updates
  React.useEffect(() => {
    setVersion(employee?.photo_updated_at || 0);
    setFailed(false);
  }, [employee?.photo_updated_at, employee?.id]);

  const hasPhoto = !!employee?.photo_updated_at && !failed;
  const url = `${API}/employees/${employee?.id}/photo?v=${version}`;

  const handleUpload = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    try {
      const fd = new FormData();
      fd.append("file", file);
      const { data } = await api.post(`/employees/${employee.id}/photo`, fd, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      setVersion(data.updated_at);
      setFailed(false);
      toast.success("Foto atualizada");
      onChange?.(data.updated_at);
    } catch (err) {
      toast.error(err.response?.data?.detail || "Falha ao enviar foto");
    } finally {
      if (fileRef.current) fileRef.current.value = "";
    }
  };

  const baseStyles = {
    width: size,
    height: size,
  };

  return (
    <div className="relative inline-block group" style={baseStyles}>
      {hasPhoto ? (
        <img
          src={url}
          alt="Foto"
          onError={() => setFailed(true)}
          className="w-full h-full rounded-full object-cover bg-brand-50"
          style={baseStyles}
        />
      ) : (
        <div
          className="w-full h-full rounded-full bg-brand-900 text-white flex items-center justify-center font-medium"
          style={{ ...baseStyles, fontSize: size * 0.36 }}
        >
          {initials(employee?.name)}
        </div>
      )}
      {editable && (
        <>
          <button
            type="button"
            onClick={() => fileRef.current?.click()}
            data-testid={`upload-photo-${employee?.id}`}
            className="absolute inset-0 rounded-full bg-black/0 group-hover:bg-black/40 transition-colors flex items-center justify-center opacity-0 group-hover:opacity-100"
            title="Trocar foto"
          >
            <Camera className="w-5 h-5 text-white" />
          </button>
          <input
            ref={fileRef}
            type="file"
            accept="image/*"
            className="hidden"
            onChange={handleUpload}
          />
        </>
      )}
    </div>
  );
}
